import { Bot, User } from 'lucide-react';
import { cn } from '@/lib/utils';

export default function MessageBubble({ from, content }) {
  const isUser = from === 'user';
  return (
    <div className={cn('flex gap-2 items-start', isUser && 'flex-row-reverse')}>
      <div
        className={cn(
          'flex h-8 w-8 shrink-0 items-center justify-center rounded-full',
          isUser ? 'bg-[#004263] text-white' : 'bg-[#E8F7FF] text-[#004263]',
        )}
      >
        {isUser ? <User className="h-4 w-4" /> : <Bot className="h-4 w-4" />}
      </div>
      <div
        className={cn(
          'max-w-[78%] rounded-2xl px-3 py-2 text-sm leading-snug whitespace-pre-wrap break-words',
          isUser
            ? 'bg-[#004263] text-white rounded-tr-sm'
            : 'bg-[#F5F5F5] text-gray-800 rounded-tl-sm',
        )}
      >
        {content}
      </div>
    </div>
  );
}
